import { render } from "./CreateOrModify.vue?vue&type=template&id=6736bfd0"
import script from "./CreateOrModify.vue?vue&type=script&lang=ts"
export * from "./CreateOrModify.vue?vue&type=script&lang=ts"

import "./CreateOrModify.vue?vue&type=style&index=0&id=6736bfd0&lang=scss"
script.render = render

export default script